import type { AvailabilityDetails } from "@efood-commerce-sdk/typescript-axios-transaction-efood";

export const DEFAULT_AVAILABILITY: AvailabilityDetails = {
  pending: false,
  withOrderSplit: false,
  message: "",
  messageKey: "IS_AVAILABLE",
  replenishmentDate: null,
};
